import type { I18nFn } from '#/i18n/types/I18nFn';

export function INTAKE_INTENTS(i18n: I18nFn) {
  return [
    {
      name: 'VOLUNTEER',
      label: i18n('Volunteer or take action in my community'),
    },
    {
      name: 'LOOKING_FOR_JOB',
      label: i18n('Find a job or intersnhip'),
    },
    {
      name: 'POST_JOB_OR_OTHER_OPP',
      label: i18n('Post on Idealist'),
    },
  ] as const;
}
